
const digest = '290bd98f497f64b41d6141c31e22ebd701193f0ce0c92ef36b5e1c8188f24d6a';
const classes = {"red":"_red_1aghn_1","orange":"_orange_1aghn_5","green":"_green_1aghn_9"};
const css = `._red_1aghn_1 {
  background-color: #f12848;
}

._orange_1aghn_5 {
  background-color: #ff842c;
}

._green_1aghn_9 {
  background-color: #619612;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  